export const images = {
  project_images: [
    {
      id: "logo",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1757610403/Ever%20Last%20Apps/IMG_8776_lds9ba.png",
      cloudName: "dyzydm9nl",
    },
    {
      id: "career landing image 1",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1674170508/Ever%20Last%20Apps/4452961_k9kn7m.jpg",
      cloudName: "dyzydm9nl",
    },
    {
      id: "about image",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1677868434/Ever%20Last%20Apps/photo-1531297484001-80022131f5a1_vtgkly.jpg",
      cloudName: "dyzydm9nl",
    },
  ],
  about: [
    {
      id: "website development",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1678387815/Ever%20Last%20Apps/photo-1593720213428-28a5b9e94613_h05boi.jpg",
      cloudName: "dyzydm9nl",
    },
    {
      id: "tech optimiation",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1678387984/Ever%20Last%20Apps/photo-1573497491208-6b1acb260507_nfvskl.jpg",
      cloudName: "dyzydm9nl",
    },
    {
      id: "app development",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1679437236/Ever%20Last%20Apps/photo-1512941937669-90a1b58e7e9c_iq5pwi.jpg",
      cloudName: "dyzydm9nl",
    },
    {
      id: "marketing",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1678388171/Ever%20Last%20Apps/photo-1533750349088-cd871a92f312_fhslx2.jpg",
      cloudName: "dyzydm9nl",
    },
  ],
  reputation_images: [
    {
      id: "1",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1772468795/Screen_Shot_2026-03-02_at_11.24.21_AM_knk46v.png",
      cloudName: "dyzydm9nl",
      name: "Shophr Retailers",
      redirect: "https://retailers.shophr.co/",
      description: "Shophr Retailers",
    },
    {
      id: "4",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1757606878/Ever%20Last%20Apps/Screen_Shot_2025-09-11_at_11.19.25_AM_nuyozi.png",
      cloudName: "dyzydm9nl",
      name: "Chance To Advance LLC",
      redirect: "https://chance-to-advance.onrender.com/",
      description: "Chance To Advance LLC",
    },
    {
      id: "2",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1672457364/Ever%20Last%20Apps/Screen_Shot_2022-12-30_at_10.27.30_PM_yxzgdf.png",
      cloudName: "dyzydm9nl",
      name: "Beary Soft Organic",
      redirect: "https://bearysoftorganic.netlify.app",
      description: "Beary Soft Organic",
    },
  ],
  app_projects: [
    {
      id: "shophr-app",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1783651384/iconOrangeLarge_oe3atf.png",
      cloudName: "dyzydm9nl",
      name: "Shophr",
      redirect: "https://apps.apple.com/us/app/shophr/id6760482282",
      description: "Shophr mobile app",
    },
    {
      id: "shophr-driver",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1783651520/shophr-driver-logo_eyxzoj.png",
      cloudName: "dyzydm9nl",
      name: "Shophr Driver",
      redirect: "https://apps.apple.com/us/app/shophr-drive/id6760732986",
      description: "Shophr Driver mobile app",
    },
  ],
  careersImages: [
    {
      id: "NY",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1674176991/Ever%20Last%20Apps/26313_q4j2ru.jpg",
      cloudName: "dyzydm9nl",
      name: "New York, NY",
      options: "location",
    },
    {
      id: "NC",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1674177038/Ever%20Last%20Apps/asheville-city-downtown-north-carolina-aerial-view_ceyffw.jpg",
      cloudName: "dyzydm9nl",
      name: "Raleigh, NC",
      options: "location",
    },
    {
      id: "AL",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1674177057/Ever%20Last%20Apps/albany-new-york-skyline_zbmzrf.jpg",
      cloudName: "dyzydm9nl",
      name: "Albany, NY",
      options: "location",
    },
    {
      id: "VA",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1674179233/Ever%20Last%20Apps/richmond-virginia-usa-neighborhoods_naz9fe.jpg",
      cloudName: "dyzydm9nl",
      name: "Richmond, VA",
      options: "location",
    },
    {
      id: "culture",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1674181258/Ever%20Last%20Apps/photo-1568992687947-868a62a9f521_u4gckm.jpg",
      cloudName: "dyzydm9nl",
    },
    {
      id: "web dev career",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1674319224/Ever%20Last%20Apps/cxwcg53wzdf2znpb2gil.jpg",
      cloudName: "dyzydm9nl",
      options: "skills",
    },
    {
      id: "ui career",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1674294482/Ever%20Last%20Apps/photo-1581291518633-83b4ebd1d83e_ishbdw.jpg",
      cloudName: "dyzydm9nl",
      options: "skills",
    },
    {
      id: "social media career",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1674294511/Ever%20Last%20Apps/premium_photo-1661425715124-310ec1b49b8a_pgjgh8.jpg",
      cloudName: "dyzydm9nl",
      options: "skills",
    },
  ],
  reviews: [
    {
      id: "review1",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1679280502/Ever%20Last%20Apps/Cream_Beige_Minimal_Client_Reviews_Instagram_Post_7_hz5zvf.jpg",
      cloudName: "dyzydm9nl",
    },
    {
      id: "review4",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1679509063/Ever%20Last%20Apps/Cream_Beige_Minimal_Client_Reviews_Instagram_Post_why410.jpg",
      cloudName: "dyzydm9nl",
    },
    {
      id: "review2",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1679280863/Ever%20Last%20Apps/Cream_Beige_Minimal_Client_Reviews_Instagram_Post_9_rj6zhy.jpg",
      cloudName: "dyzydm9nl",
    },
    {
      id: "review3",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1679281120/Ever%20Last%20Apps/Cream_Beige_Minimal_Client_Reviews_Instagram_Post_10_ilxrfg.jpg",
      cloudName: "dyzydm9nl",
    },
  ],
  webdev: [
    {
      id: "consultaion",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1679358111/Ever%20Last%20Apps/photo-1616587894289-86480e533129_yvgyxc.jpg",
      cloudName: "dyzydm9nl",
    },
    {
      id: "working",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1679359307/Ever%20Last%20Apps/137-1379308_website-work-in-progress_tl7zbb.jpg",
      cloudName: "dyzydm9nl",
    },
    {
      id: "finished",
      image:
        "https://res.cloudinary.com/dyzydm9nl/image/upload/v1679365514/Ever%20Last%20Apps/download_xuasyd.png ",
      cloudName: "dyzydm9nl",
    },
  ],
};
